import { Refresh as RefreshIcon } from '@mui/icons-material';
import React from 'react';
import styled from 'styled-components';
import StyledProps from '../theme/AppThemeInterface';


export interface RefreshProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {}
const Refresh = (props: RefreshProps) => {
  return (
    <FilterButton {...props}>
      <RefreshIcon />
    </FilterButton>
  );
};
export default Refresh;

const FilterButton = styled.div`
  height: 35px;
  margin-left: 1rem;
  border: 1px solid #141d24;
  border-radius: 4px;
  background-color: #16232c;
  padding: 0px 6px;

  display: flex;
  align-items: center;
  justify-content: center;

  color: ${({ theme }: StyledProps) => theme.primaryTextColor};
  font-family: ${({ theme }: StyledProps) => theme.appFontFamily};
  font-size: 14px;

  svg {
    color: #a9aeb1;
  }

  &:hover {
    cursor: pointer;
    text-decoration: underline;
    background-color: #1e2e3a;

    svg {
      color: white;
    }
  }
`;
